/* fix typescript */
import { Operator } from 'rxjs/Operator';
import { Observable } from 'rxjs/Observable';

declare module 'rxjs/Subject' {
  interface Subject<T> {
    lift<R>(operator: Operator<T, R>): Observable<R>;
  }
}
/* end */

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { QuestionComponent } from './pages';
import { SafeHtmlPipe } from './pipes';
import { EmbedModalComponent } from './modals/';
import { HeaderComponent, FooterComponent, NavComponent } from './shared';
import { QuestionsService } from './services';
import { routing } from './app.routing';



@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    routing
  ],
  declarations: [
    AppComponent,
    NavComponent,
    HeaderComponent,
    FooterComponent,
    QuestionComponent,
    SafeHtmlPipe,
    EmbedModalComponent
  ],
  providers: [
    QuestionsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts